import PropTypes from 'prop-types';
import styles from './AudioPlayer.module.scss';

// Components
import Player from '../Player/Player';
import { useSampleDownloadSelector } from "../../utils/useSampleDownloadSelector";
import Modal from "../Modal";
import DownloadProductChooserModal from "../DownloadProductChooserModal";
import { useEffect, useRef } from 'react';

const AudioPlayer = ({
    audio,
    download = true,
    id,
    onToggleDownload = () => null,
    productList,
    selectedProduct,
    onPlay,
    onPause,
    onDownload
}) => {
    const { getDownloadSampleInstrumentUrlForSpecificInstrument } = useSampleDownloadSelector()
    const downloadSelectedUrl = selectedProduct && selectedProduct.value ? getDownloadSampleInstrumentUrlForSpecificInstrument(selectedProduct.value, id) : null;
    const playerRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                playerRef.current &&
                !playerRef.current.contains(event.target)
            ) {
                onPause();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ onPause]);

    return (
        <div className={styles['AudioPlayer']} ref={playerRef}>
            {/* {download && <input type="checkbox" id="AudioPlayer__Checkbox" value={id} onChange={onToggleDownload} />} */}

            <div className={styles['AudioPlayer__Title']}>
                {audio && audio.title && <h3>{audio.title}</h3>}
                {audio && audio.type && (
                    <p className={styles['AudioPlayer__Type']}>{audio.type}</p>
                )}
            </div>

            {audio && audio.file && (
                <div className={styles['AudioPlayer__Player']}>
                    <Player
                        audio={audio.file}
                        onPlay={onPlay}
                        onPause={onPause}
                    />
                </div>
            )}

            {download && <Modal
                buttonText={`Download ${audio.title}`}
                buttonType={"onlyIcon"}
                downloadLink={{ href: downloadSelectedUrl }}
            >
                <DownloadProductChooserModal
                    compatibleProducts={productList}
                    title={audio.title}
                    onDownload={onDownload}
                />
            </Modal>}
        </div>
    );
};

AudioPlayer.propTypes = {
    audio: PropTypes.shape({
        file: PropTypes.string.isRequired,
        title: PropTypes.string,
    }).isRequired,
    download: PropTypes.bool,
};

AudioPlayer.defaultProps = {
    audio: {
        file: '',
        title: '',
    },
    download: false,
};

export default AudioPlayer;
